import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** RichText property - Definition */
export class DocsBlockMultiRichTextPropertyDefinition extends DocsBlockPropertyDefinition {
}
